import React, { useState, useEffect, useMemo } from 'react';
import { Box, Divider, Chip, Stack, Alert, Typography } from '@mui/material';
import ModalDetalleRespuestas from 'views/Reportes/Components/ModalDetalleRespuestas';
import ServiciosCalificacion from './ServiciosCalificacion';

const TIPOS_ENCUESTA = [7, 11, 12];

const mapearPreguntas = (preguntas = []) =>
    preguntas.map((preg) => {
        if (preg.esAbierta) {
            return {
                idPregunta: preg.idPregunta,
                npregunta: preg.npregunta,
                esAbierta: true,
                respuestaTexto: preg.respuestas?.[0]?.comentario || ''
            };
        }

        return {
            idPregunta: preg.idPregunta,
            npregunta: preg.npregunta,
            esAbierta: false,
            esCorrecta: preg.isCorrecta,
            opciones: (preg.respuestas || []).map((rsp) => ({
                idRespuesta: rsp.idRespuesta,
                nrespuesta: rsp.nrespuesta,
                isCorrecta: rsp.isCorrecta ? 1 : 0,
                seleccionada: rsp.idRespuestaUsuario != null ? 1 : 0
            }))
        };
    });

const OpcRegistro = (props) => {
    const { data } = props;
    const serviciosCalificacion = ServiciosCalificacion();
    const [examen, setExamen] = useState(null);
    const [cargado, setCargado] = useState(false);

    useEffect(() => {
        serviciosCalificacion.getDetalleUltimoIntentoExamen(
            (res) => {
                setExamen(res?.data || null);
                setCargado(true);
            },
            {
                idDetalleActividad: data.idDetalleActividad,
                idColaborador: data.idColaborador,
                idCalificacionDetalle: data.idCalificacionDetalle || null
            }
        );
    }, []);

    const preguntasMapeadas = useMemo(() => mapearPreguntas(examen?.preguntas), [examen]);

    const esEncuesta = TIPOS_ENCUESTA.includes(Number(examen?.idTipoActividad ?? data?.tipo));

    if (!cargado) return null;

    if (!examen || preguntasMapeadas.length === 0) {
        return <Alert severity="info">No hay respuestas registradas para este examen.</Alert>;
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Stack direction="row" spacing={1} sx={{ mb: 2 }} flexWrap="wrap" useFlexGap>
                <Chip size="small" label={`Intento ${examen.numIntento} de ${examen.totalIntentos}`} />
                {!esEncuesta && (
                    <>
                        <Chip
                            size="small"
                            color={Number(examen.intento?.isAprobado) === 1 ? 'success' : 'error'}
                            label={Number(examen.intento?.isAprobado) === 1 ? 'Aprobado' : 'No aprobado'}
                        />
                        <Chip size="small" color="primary" label={`Calificación: ${examen.intento?.calificacion ?? '-'}%`} />
                        <Chip size="small" variant="outlined" label={`Aciertos: ${examen.intento?.aciertos ?? 0}`} />
                        <Chip size="small" variant="outlined" label={`Desaciertos: ${examen.intento?.desaciertos ?? 0}`} />
                    </>
                )}
                <Chip size="small" variant="outlined" label={`Fecha: ${examen.intento?.fechaCreacion ?? '-'}`} />
            </Stack>

            <Divider sx={{ mb: 2 }} />

            <ModalDetalleRespuestas data={preguntasMapeadas} esEncuesta={esEncuesta} />
        </Box>
    );
};

export default OpcRegistro;
